import { Directive, Input, ElementRef, HostListener } from '@angular/core';
import { SharedService } from 'app/shared/services/shared.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';

@Directive({
  selector: '[tooltip]',
})
export class TooltipDirective {
  @Input() tooltipKey: string;
  @Input() tooltipWithoutDictionary: boolean;
  @Input() tooltipCondition: boolean;
  @Input() tooltipCentered: boolean;
  @Input() tooltipEditable: boolean;
  @Input() tooltipForceTop: boolean;

  constructor(public el: ElementRef, public sharedService: SharedService, public dictionaryService: DictionaryService) {
    this.tooltipWithoutDictionary = false;
    this.tooltipCondition = true;
    this.tooltipCentered = false;
    this.tooltipEditable = false;
    this.tooltipForceTop = false;
  }

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.sharedService.isMobile() && this.tooltipCondition && !this.sharedService.isEmpty(this.tooltipKey)) {
      this.sharedService.tooltipTimeout = setTimeout(() => {
        const title: string = this.tooltipWithoutDictionary
          ? this.tooltipKey
          : this.dictionaryService.get(this.tooltipKey);
        const element: HTMLElement = this.el.nativeElement as HTMLElement;
        this.sharedService.showTooltip(
          title,
          element,
          this.tooltipEditable,
          this.tooltipCentered,
          this.tooltipForceTop
        );
      }, 500);
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (!this.sharedService.isMobile() && !this.sharedService.tooltipData.visible) {
      this.sharedService.hideTooltip();
    }
  }

  ngOnDestroy() {
    if (!this.sharedService.isMobile()) {
      this.sharedService.hideTooltip();
    }
  }
}
